import { schema } from 'normalizr';

const SUBSCRIPTION_SCHEMA = new schema.Entity('subscriptions', {}, { idAttribute: '@id' });
const SUBSCRIPTION_OPTION_SCHEMA = new schema.Entity('subscriptionOptions', {}, { idAttribute: '@id' });

export default {
  Subscription: SUBSCRIPTION_SCHEMA,
  SubscriptionOption: SUBSCRIPTION_OPTION_SCHEMA,
};
